import React from "react";
import { observer } from "mobx-react";
import { ReportCreateStore } from "../../store";
import { ReportCreateForm } from "./ReportCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type ReportCreateProps = {
  reportCreateStore: ReportCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const ReportCreate: React.FC<ReportCreateProps> = observer(
  ({ reportCreateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={reportCreateStore.isSaving} />
        <ReportCreateForm
          reportCreateStore={reportCreateStore}
          nameError={reportCreateStore.errors.name?.message}
          onNameChange={(value: string) => {
            reportCreateStore.setNameValue(value);
          }}
          name={reportCreateStore.entityValues.name}
          reportTypeError={reportCreateStore.errors.reportType?.message}
          onReportTypeChange={(value) => {
            reportCreateStore.setReportTypeValue(value);
          }}
          reportTypeSelectedValue={
            reportCreateStore.entityValues.showReportType
          }
          onReportTypeSelected={(value) => {
            reportCreateStore.setSelectedReportType(value);
          }}
          reportTypeOptions={reportCreateStore.getReportTypeOptions()}
          templateError={reportCreateStore.errors.template?.message}
          onTemplateChange={(value: string) => {
            reportCreateStore.setTemplateValue(value);
          }}
          template={reportCreateStore.entityValues.template}
          constantsError={reportCreateStore.errors.constants?.message}
          onConstantsChange={(value: string) => {
            reportCreateStore.setConstantsValue(value);
          }}
          constants={reportCreateStore.entityValues.constants}
          descriptionError={reportCreateStore.errors.description?.message}
          onDescriptionChange={(value: string) => {
            reportCreateStore.setDescriptionValue(value);
          }}
          description={reportCreateStore.entityValues.description}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={reportCreateStore.isProcessing}
          onSave={() => reportCreateStore.saveNewReport()}
          onCancel={() => reportCreateStore.cancelNewReport()}
        />
        <ErrorDialog
          open={reportCreateStore.errorDialogOpened}
          title={reportCreateStore.errorTitle}
          description={reportCreateStore.errorDescription}
          onClose={() => reportCreateStore.closeErrorDialog()}
        />
      </>
    );
  }
);
